// Behaviour for snippets/cart-drawer-extras.liquid.
// Uses document-level listeners because Dawn replaces the drawer markup on every cart change.
(function () {
  const TIMER_KEY = 'cdx-timer-end';

  function refreshDrawer() {
    return fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
        const drawerHtml = parse(sections['cart-drawer']);
        const newInner = drawerHtml.querySelector('.drawer__inner');
        const inner = document.querySelector('#CartDrawer .drawer__inner');
        if (newInner && inner) inner.innerHTML = newInner.innerHTML;

        const drawer = document.querySelector('cart-drawer');
        const newDrawer = drawerHtml.querySelector('cart-drawer');
        if (drawer && newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));

        const bubble = document.getElementById('cart-icon-bubble');
        const newBubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;

        startTimer();
      });
  }

  function updateCart(body) {
    return fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  }

  // Upsell: add the chosen variant, then re-render the drawer.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cdx-upsell-add]');
    if (!button) return;
    const item = button.closest('.cdx-upsell__item');
    const select = item && item.querySelector('.cdx-upsell__variant');
    const variantId = select ? select.value : button.dataset.variantId;

    button.disabled = true;
    button.classList.add('loading');
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(refreshDrawer)
      .catch((e) => {
        console.error(e);
        button.disabled = false;
        button.classList.remove('loading');
      });
  });

  // Discount code: apply, or show an error when Shopify rejects it.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cdx-discount-form]');
    if (!form) return;
    event.preventDefault();

    const code = form.elements.discount.value.trim();
    const wrapper = form.closest('[data-cdx-discount]');
    const error = wrapper.querySelector('[data-cdx-discount-error]');
    const button = form.querySelector('button');
    if (!code) return;

    error.hidden = true;
    button.disabled = true;

    const existing = Array.from(wrapper.querySelectorAll('.cdx-discount__code span')).map((el) => el.textContent.trim());
    updateCart({ discount: [...existing, code].join(',') })
      .then((cart) => {
        const match = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (!match || !match.applicable) {
          // Put back only the codes that were already there.
          return updateCart({ discount: existing.join(',') }).then(() => {
            error.hidden = false;
            button.disabled = false;
          });
        }
        return refreshDrawer();
      })
      .catch((e) => {
        console.error(e);
        error.hidden = false;
        button.disabled = false;
      });
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cdx-discount-remove]');
    if (!button) return;
    const wrapper = button.closest('[data-cdx-discount]');
    const removed = button.closest('.cdx-discount__code').querySelector('span').textContent.trim();
    const remaining = Array.from(wrapper.querySelectorAll('.cdx-discount__code span'))
      .map((el) => el.textContent.trim())
      .filter((c) => c !== removed);

    button.disabled = true;
    updateCart({ discount: remaining.join(',') }).then(refreshDrawer).catch((e) => console.error(e));
  });

  // Variant dropdowns: swap the cart line to the chosen color/size, keeping quantity and properties.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cdx-option]');
    if (!select) return;
    const wrapper = select.closest('[data-cdx-variant]');
    const error = wrapper.querySelector('[data-cdx-variant-error]');
    const variants = JSON.parse(wrapper.querySelector('[data-cdx-variants]').textContent);
    const chosen = Array.from(wrapper.querySelectorAll('[data-cdx-option]')).map((s) => s.value);
    const match = variants.find((v) => v.options.every((value, i) => value === chosen[i]));

    if (!match || !match.available) {
      error.hidden = false;
      return;
    }
    error.hidden = true;
    if (String(match.id) === wrapper.dataset.variantId) return;

    const line = Number(wrapper.dataset.line);
    const quantity = Number(wrapper.dataset.quantity);
    wrapper.querySelectorAll('select').forEach((s) => (s.disabled = true));

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const properties = (cart.items[line - 1] && cart.items[line - 1].properties) || {};
        return fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity: 0 }),
        }).then(() =>
          fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: match.id, quantity, properties }] }),
          })
        );
      })
      .then(refreshDrawer)
      .catch((e) => {
        console.error(e);
        refreshDrawer();
      });
  });

  // Reservation timer: counts down once per browser session, then hides itself.
  let timerInterval;
  function startTimer() {
    const el = document.querySelector('[data-cdx-timer]');
    clearInterval(timerInterval);
    if (!el) return;

    let end;
    try {
      end = Number(sessionStorage.getItem(TIMER_KEY));
      if (!end) {
        end = Date.now() + Number(el.dataset.minutes || 15) * 60000;
        sessionStorage.setItem(TIMER_KEY, String(end));
      }
    } catch (e) {
      end = Date.now() + Number(el.dataset.minutes || 15) * 60000;
    }

    const value = el.querySelector('[data-cdx-timer-value]');
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      if (left === 0) {
        el.hidden = true;
        clearInterval(timerInterval);
        return;
      }
      const m = Math.floor(left / 60000);
      const s = Math.floor((left % 60000) / 1000);
      if (value) value.textContent = `${m}:${String(s).padStart(2, '0')}`;
      el.hidden = false;
    };
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  // Dawn swaps the drawer markup after add-to-cart and quantity changes; restart the timer when that happens.
  const observeDrawer = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    new MutationObserver(() => {
      const el = document.querySelector('[data-cdx-timer]');
      if (el && el.hidden) startTimer();
    }).observe(drawer, { childList: true, subtree: true });
    startTimer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();
